import { render, staticRenderFns } from "./StaticLandingPageStepGeneralInfo.vue?vue&type=template&id=61c1aa5f&scoped=true&"
import script from "./StaticLandingPageStepGeneralInfo.vue?vue&type=script&lang=js&"
export * from "./StaticLandingPageStepGeneralInfo.vue?vue&type=script&lang=js&"
import style0 from "./StaticLandingPageStepGeneralInfo.vue?vue&type=style&index=0&id=61c1aa5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c1aa5f",
  null
  
)

export default component.exports